/* RESPONSIBLE TEAM: team-standalone */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export class ManageMigrationIndexRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(ManageMigrationIndexRoute);
